import { render, staticRenderFns } from "./AssignedPreordersTable.vue?vue&type=template&id=ee63f9b8&"
import script from "./AssignedPreordersTable.vue?vue&type=script&lang=js&"
export * from "./AssignedPreordersTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports